<template lang="pug">
.card-inteligencia-territorial-imoveis
    .card-inteligencia-territorial-imoveis-interno--titulo-total(style='margin-top: 8px !important') {{ $t('mensagens.inteligenciaTerritorial.totalDeImoveis') }}:
    .card-inteligencia-territorial-imoveis-interno--valor(style='margin-left: 2px') {{ formatoNumero(imoveis.quantidadeTotalCar) }}
    .separador-personalizado
    .card-inteligencia-territorial-imoveis-interno--titulo-total.subtitulo {{ $t('mensagens.inteligenciaTerritorial.area') }}:
    .card-subgrupos
        .valores
            .card-inteligencia-territorial-imoveis-interno--titulo-total {{ $t('mensagens.operacao.dashboard.total') }}:
            .valor-informado(style='margin-bottom: 20px') {{ formatoNumero(imoveis.areaHa) }} ha
        .valores
            .card-inteligencia-territorial-imoveis-interno--titulo-total {{ $t('mensagens.inteligenciaTerritorial.media') }}:
            .valor-informado(style='margin-bottom: 20px') {{ formatoNumero(imoveis.areaHa / imoveis.quantidadeTotalCar) }} ha
    .separador-personalizado
    .card-inteligencia-territorial-imoveis-interno--titulo-total.subtitulo {{ $t('mensagens.inteligenciaTerritorial.areaImoveis') }}:
    .card-subgrupos
        .valores
            .card-inteligencia-territorial-imoveis-interno--titulo-total {{ $t('mensagens.inteligenciaTerritorial.menoresQueCinquenta') }} ha
            .valor-informado(v-if='totalImovelMenor50Ha')
                | {{ formatoNumero(totalImovelMenor50Ha) }}
                span(style="color: var(--secondary-two); padding-left: 12px;") {{ calculandoPorcentagem(imoveis.quantidadeTotalCar, totalImovelMenor50Ha) }}%
            .valor-informado(v-else) -
        .valores
            .card-inteligencia-territorial-imoveis-interno--titulo-total {{ $t('mensagens.inteligenciaTerritorial.entreCinquentaEMil') }} ha
            .valor-informado(v-if='totalImovelEntre50e1000Ha')
                | {{ formatoNumero(totalImovelEntre50e1000Ha) }}
                span(style="color: var(--secondary-two); padding-left: 12px") {{ calculandoPorcentagem(imoveis.quantidadeTotalCar, totalImovelEntre50e1000Ha) }}%
            .valor-informado(v-else) -
    .card-subgrupo-especifico
        .card-inteligencia-territorial-imoveis-interno--titulo-total {{ $t('mensagens.inteligenciaTerritorial.maioresQueMil') }} ha
        .valor-informado(v-if='totalImovelMaior1000')
            | {{ formatoNumero(totalImovelMaior1000) }}
            span(style="color: var(--secondary-two); padding-left: 12px;") {{ calculandoPorcentagem(imoveis.quantidadeTotalCar, totalImovelMaior1000) }}%
        .valor-informado(v-else) -
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'CardInteligenciaTerritorialImoveis',
    props: {
        imoveis: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            totalImovelMenor50Ha: null,
            totalImovelEntre50e1000Ha: null,
            totalImovelMaior1000: null
        };
    },
    watch: {
        imoveis: function () {
            this.calcularImoveis();
        }
    },
    methods: {
        formatoNumero(number) {
            return formatters.formatNumber(number, 0);
        },
        calculandoPorcentagem(total, number) {
            var resultado = (((total - number) / total) * 100 - 100) * -1;
            return this.formatoNumero(resultado);
        },
        calcularImoveis() {
            this.totalImovelMenor50Ha = 0;
            this.totalImovelEntre50e1000Ha = 0;
            this.totalImovelMaior1000 = 0;

            if (this.imoveis.imoveisMenoresQue50Ha) {
                this.totalImovelMenor50Ha = this.imoveis.imoveisMenoresQue50Ha;
            } else {
                this.totalImovelMenor50Ha = this.imoveis.totalImovelMenor50Ha;
            }

            if (this.imoveis.imoveisDe50HaA1000Ha) {
                this.totalImovelEntre50e1000Ha = this.imoveis.imoveisDe50HaA1000Ha;
            } else {
                this.totalImovelEntre50e1000Ha = this.imoveis.totalImovelEntre50e1000Ha;
            }

            if (this.imoveis.imoveisMaioresQue1000Ha) {
                this.totalImovelMaior1000 = this.imoveis.imoveisMaioresQue1000Ha;
            } else {
                this.totalImovelMaior1000 = this.imoveis.totalImovelMaior1000;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.card-inteligencia-territorial-imoveis {
    height: 450px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    flex-direction: column;
    padding: 7px 15px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;
}

.card-inteligencia-territorial-imoveis-interno--titulo-total {
    font-size: 16px;
    font-weight: 400;
    white-space: nowrap;
    padding: 3px 0px;
    margin-top: 3px;
}

.subtitulo {
    padding-left: 8px !important;
}

.card-inteligencia-territorial-imoveis-interno--valor {
    color: var(--primary);
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 26px;
}
.valores {
    display: flex;
    flex-direction: column;
    padding: 0 8px;
}
.card-subgrupos {
    display: flex;
    margin-top: 8px;
    gap: 16px;
}
.valor-informado {
    color: var(--primary);
    font-size: 16px;
    font-weight: 600;
    margin-top: 5px;
}

.card-subgrupo-especifico {
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    padding: 0 8px;
}
.separador-personalizado {
    border: 2px;
    width: 45px;
    margin-left: 8px;
    border-top: 2px solid var(--secondary-two);
}
</style>
